import type { FormErrors } from 'redux-form';

interface TagFormProps<T> {
	validate: (values: T) => FormErrors<T>;
}

export function validate<T>(values: T, props: TagFormProps<T>): FormErrors<T> {
	return props.validate(values);
}
